import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import { dynamicDataAttribute } from 'helpers/utils'
import kebabCase from 'lodash/kebabCase'

const QuoteSummary = ({
  className,
  title,
  price,
  important,
  total,
  bolder,
  savingField,
  displaymessage,
  phoneNumber,
  compress,
  atId,
  ...props
}) =>
  <Block { ...dynamicDataAttribute(kebabCase(title)) } className={ className } { ...props }>
    <Price
      data-at-initial-quote-summary
      { ...dynamicDataAttribute(`${kebabCase(title)}-title`) }
      important={ important }
      total={ total }
      compress={ compress }
      savingField={ savingField }
      left>
      { title }
    </Price>
    {
      !price && displaymessage ?
        <Price
          data-at-quote-instant-savings
          { ...dynamicDataAttribute(`${kebabCase(title)}-message`) }
          important={ important }
          total={ total }
          bolder={ bolder }
          right
          smaller
          phoneNumber={ phoneNumber }>
          { displaymessage }<br />
          { phoneNumber }
        </Price> :
        <Price
          data-at-quote-instant-savings
          { ...dynamicDataAttribute(`${kebabCase(title)}-price`) }
          important={ important }
          savingField={ savingField }
          total={ total }
          bolder={ bolder }
          right>
          { savingField ? '-' : '' }${ Math.abs(price).toFixed(2) }
        </Price>
    }
  </Block>

QuoteSummary.propTypes = {
  atId: PropTypes.string,
  bolder: PropTypes.bool,
  className: PropTypes.string,
  compress: PropTypes.bool,
  displaymessage: PropTypes.string,
  important: PropTypes.bool,
  phoneNumber: PropTypes.string,
  price: PropTypes.number,
  savingField: PropTypes.bool,
  title: PropTypes.string,
  total: PropTypes.bool
}

export default QuoteSummary

const Block = styled.div`
  ${Mixin.responsive('padding-right', '20px', '0')}
  ${Mixin.clearFix()}
`

const Price = styled.span`
  line-height: ${props => props.compress ? '18px' : '30px'};
  color: ${Theme.colors.sub_grey};
  ${props => props.important && css`
    color: ${Theme.colors.dark_red};
  `}
  ${props => props.total && css`
    color: ${Theme.colors.sub_grey};
    ${Mixin.font.GothamBold(18)}
  `}
  ${props => props.savingField && css`
    color: ${Theme.colors.green};
    ${Mixin.font.GothamBold(15)}
  `}
  ${props => props.bolder && css`
    font-weight: 700;
  `}
  ${props => props.right && css`
    float: right;
  `}
  ${props => props.left && css`
    float: left;
    max-width: ${props => props.compress ? '160px' : '230px'};
    padding-right: 5px;
  `}
  ${props => props.smaller && css`
    font-size: 13px;
    line-height: ${props => props.phoneNumber ? '18px' : '33px'};
  `}
`
